<template>
  <div class="container">

    <div class="logo"><img src="../../assets/img/index/logo.png"></div>
    <div class="title-sub">为广大用户打造一个安心、便捷的专业服务平台</div>
    <div class="index-brand"><img src="../../assets/img/index/branding4.svg"></div>
<!--     <div class="index-brand "><a href="" @click="goto('/coupon-get-success')"><img src="/static/img/promo/10off.jpg" style="border-radius: 10px;"></a></div>
 -->
    <div class="index-brand "><img src="../../assets/img/index/promo-default.png" style="border-radius: 10px;"></div>
    <div class="service">
      <div class="parent">
        <router-link to="/move-step1">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/banjia.svg">
            <div>搬家</div>
          </div>
        </router-link>

        <router-link to="/cleanex/guide">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/qingjie.svg">
            <div>清洁</div>
          </div>
        </router-link>

        <router-link to="/storage-abstract">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/xinglijicun.svg">
            <div>行李寄存</div>
          </div>
        </router-link>

        <router-link to="/baggage-step1">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/xinglijihuiguo.svg">
            <div>行李回国</div>
          </div>
        </router-link>
      </div>

      <div class="parent">

        <router-link to="/organization/abstract">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/organization.svg">
            <div>收纳整理</div>
          </div>
        </router-link>

        <router-link to="/pest-abstract">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/chuchong.svg">
            <div>除虫除鼠</div>
          </div>
        </router-link>
      
        <router-link to="/service/car">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/jiesongji.svg">
            <div>接送机</div>
          </div>
        </router-link>

        <!-- <router-link to="/service/disinfect">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/zhuanyexiaodu.svg">
            <div>专业消毒</div>
          </div>
        </router-link>
 -->

        <router-link to="/service/convey">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/tihuoanzhuang.svg">
            <div>提货安装</div>
          </div>
        </router-link>



        <!-- <a href="//www.daojia.com.au/about" target="_blank">
          <div class="index-btn">
            <img src="../../assets/img/index/icons/g.svg">
            <div>关于我们</div>
          </div>
        </a> -->
<!--         <a href="https://about.daojia.com.au/contact.html" target="_blank">
          <div class="index-btn">
            <img src="../../assets/img/index/icons/k.svg">
            <div>联系我们</div>
          </div>
        </a>  -->

      </div>
      <div class="parent">
        <router-link to="/misc/detail?id=1">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2022/xiuqiang.svg">
            <div>修墙补洞</div>
          </div>
        </router-link>

        <!-- <router-link to="/misc/detail?id=2">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2022/youqi.svg">
            <div>油漆</div>
          </div>
        </router-link> -->

        <router-link to="/misc/detail?id=29">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2022/weixiu.svg">
            <div>家庭维修</div>
          </div>
        </router-link>

        <router-link to="/misc/detail?id=30">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2022/chucao.svg">
            <div>除草园艺</div>
          </div>
        </router-link>

        <a href="https://wechat.fantuan.ca/" target="_blank">
          <div class="index-btn">
            <img src="../../assets/img/index/icon2021/fantuan.svg">
            <div>饭团外卖</div>
          </div>
        </a>
      </div>
    </div>



    <div class="recentOrder" v-show="orderHistory.length>0">
      <div class="item animated "  :class="{ fadeInUp: ifFadeInUp, fadeOutUp: ifFadeOutUp}">{{orderPop()}}</div>
    </div>

    <div class="promo-text">
      <img src="../../assets/img/index/bigindex/text3.svg">
    </div>
    
    <div class="promo-image img1">
      <div class="ptitle">澳洲首家华人生活服务平台</div>
      <div class="ptext">为广大用户打造一个安心、便捷的专业服务平台</div>
    </div>
    <div class="promo-title">
      客户反馈
    </div>

    <div class="wrap-container-wrap">
        <div class="wrap-container">
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp0.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp1.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp2.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp3.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp4.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp5.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp6.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp7.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp9.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp11.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp12.jpg">
            </div>
            <div class="box-image">
              <img src="/static/img/index/rate/hhhhp13.jpg">
            </div>
        </div>
    </div>

    <div class="promo-image img2">
      <div class="ptitle">让全球更多华人家庭生活更便捷</div>
      <div class="ptext">成为一家保持初心，持续专注的好公司</div>
    </div>

    <div class="promo-title">
      媒体报道
    </div>

    <div class="promo-base">
      <img src="../../assets/img/index/bigindex/sydney.svg" >
      <div class="promo-img-text">「橙衣军团出征，生活烦恼不生！」，到家喊出「你满意，再付钱！」的口号，已经让整个华人生活服务市场颤抖！他们用实际行动，不断获取用户好评，悉尼惊现全民背书！</div>
    </div>

    <div class="promo-image img3">
      <div class="ptitle">到家，让生活焕然一新</div>
      <div class="ptext">网络下单，上门服务，你只需轻松在家享受生活</div>
    </div>

    <transition name="fade">
      <v-modal v-show="ifNotice" @close="closeNotice()">
        <div slot="body">
          <div class="modal-title">🎄服务公告</div>
          <div class="info">
亲爱的朋友，圣诞节日期间，到家网站可正常下单。12月22日~1月1日订单量已满，您可预订1月2日后的订单。假日期间客服可能无法及时回复，非常抱歉。祝您节日快乐！<br><br>（12月24日 ~ 29日客服休息，所有在线订单将于30日统一回复确认）

          </div>
          <div class="btn-box">
            <div class="btn active" @click="closeNotice()">好的</div>
          </div>
        </div>
      </v-modal>
    </transition>
  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: 'index',
  data () {
    return {
      order:{
      },
      orderHistory:[],
      orderStats:{},
      orderPopIndex:0,
      ifFadeInUp:false,
      ifFadeOutUp:false,
      isSending:false,
      ifNotice:false,
    }
  },
  created: function () {
    document.querySelector("html").classList.add("index-bg");
    //如果localstorage存在临时的订单记录，则判断属于什么类型（搬家还是清洁），然后转而放入savedMove来保存
    if (localStorage.order) {
      let ifSaveData = JSON.parse(localStorage.order);
      if(ifSaveData.service == "move"){
        localStorage.savedMove = localStorage.order;
      }
      if(ifSaveData.service == "clean"){
        localStorage.savedClean = localStorage.order;
      }
    }
    localStorage.removeItem('order');
    localStorage.removeItem('isEditing');
    localStorage.removeItem('savedMove');
    localStorage.removeItem('savedClean');

    this.getData();
    if(localStorage.notice2020){
      this.ifNotice = false;
    }
  },
  methods: {
      closeNotice: function() {
          localStorage.notice2020 = true;
          this.ifNotice = false;
      },
      orderPopInit: function() {
          setInterval(() => { 
              this.orderPopExec();
          }, 6000)
      },
      orderPopExec: function() {
          this.ifFadeOutUp = true;
          this.ifFadeInUp = false;

          let that = this;
          setTimeout(function () {
            that.orderPopIndex = that.orderPopIndex+1;
            if(that.orderPopIndex>=that.orderHistory.length){
              that.orderPopIndex = 0;
            }
            that.ifFadeInUp = true;
            that.ifFadeOutUp = false;
          }, 2500);
      },
      orderPop:function() {
        if(this.orderHistory.length>0){
          let result = "悉尼 "+ this.orderHistory[this.orderPopIndex].buy_suburb + " 的用户刚刚预定了" +  this.orderHistory[this.orderPopIndex].buy_type + "服务";
          return result;
        }
      },
      
      shuffle:function (array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;

          // And swap it with the current element.
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
        return array;
      },
      getData(){        
        if(this.isSending){
          return false;
        }
        else{
          let that = this;
          this.axios.post(this.apiURL()+'/Order/buyList')
          .then(function (response) {
            if(response.data.error_code==0){
              that.isSending = false;
              that.orderHistory = response.data.data.history;
              that.orderHistory = that.shuffle(that.orderHistory);
              that.orderPopInit();
              that.orderStats = response.data.data.stats;
              localStorage.orderStats = JSON.stringify(that.orderStats);
            }
            else{
              that.isSending=false;
            }
          })
          .catch(function (error) {
              console.log(error)
              that.isSending=false;
          });
        }
      },
  },
  destroyed() {
    document.querySelector("html").classList.remove("index-bg");
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
@import "../../assets/css/animate.css";
.container{
  padding:0 18px;
}
.parent{
	display: flex;
	justify-content:space-around;
	align-items:center;
  padding:8px 15px;
}

.banner{
  background:#fff;
  border-radius:10px;
  margin-bottom:14px;
  font-size:0;
  img{
    width:100%;
  }
}

.service{
  background:rgba(255, 255, 255, 1);
  border-radius:10px;
  padding:8px 0;
}

.logo{
  margin-top:4vh;
  img{
    width:100%;
  }
}

.title-sub{
  color: #fff;
  font-size: 0.8em;
  text-align: left;
  margin-bottom:4vh;
}

.index-btn{
  margin:0 auto;
  color:#666;
  text-align:center;
  margin:0 0.5vw;
  font-size:0.8em;
  div{
    padding-right:2px;
  }
  img{
    width:67%;
  }
}

.btn-long{
  width: 320px;
  height: 112px;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-size: 1.2em;
  margin: 0 auto;
  margin-top: 26px;
  padding-left:30px;
  box-sizing:border-box;
  text-align:left;
  font-weight:bold;
}

.btn-intro{
  font-size:0.7em;
  font-weight:normal;
}

.btn1{
  background: rgb(255,190,68);
  background: linear-gradient(90deg, #FFBE44 0%,#FBDD88 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
  box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
}

.btn2{
  background: rgb(255,128,154);
  background: linear-gradient(90deg, #FF809A 0%,#FFAC7F 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
  box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
}

.btn3{
  background: rgb(105,205,243);
  background: linear-gradient(90deg, #69CDF3 0%,#87F5E3 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
}

.index-brand{
  margin-bottom:4px;
  img{
    width:100%;
    box-sizing:border-box;
  }
}

.recentOrder{
  padding:0 18px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing:border-box;
  color:#fff;
  text-align:center;
  position:fixed;
  bottom:70px;
  width:100%;
  left:0;
  z-index:99;
  .item{
    padding:4px 10px;
    background:rgba(254, 149, 103,0.9);
    border-radius:4px;
    font-size:0.8em;
  }
}
.promo-title{
  font-weight:bold;
  font-size:1.4em;
  color:#fff;
  margin-bottom:20px;
}
.promo-text{
  img{
    width:100%;
  }
  text-align:center;
  margin:26px 0 20px 0;
}

.promo-base{
  img{
    width:90%;
    margin-bottom:10px;
  }
  text-align:center;
  margin-top:10px;

  .promo-img-text{
    color:#fff;
    font-size:15px;
    text-align: justify;
    padding:0 5%;
    margin-bottom:30px;
  }
}

.promo-hr{
  padding:0 5%;
  div{
    border-top:1px solid rgba(255, 255, 255, 0.8);
    margin-bottom:30px;
  }
}

.promo-image{   
    height:180px;
    border-radius:10px;
    background-repeat: no-repeat;
    background-position: 50%;
    width: 100%;
    background-size: cover;
    display: flex;
    justify-content:center;
    align-items:center;
    flex-direction: column;
    margin:30px 0;
    &.img1 {
      background-image: url('/static/img/index/promo1.jpg');
    }
    &.img2 {
      background-image: url('/static/img/index/promo2.jpg');
    }
    &.img3 {
      background-image: url('/static/img/index/promo3.jpg');
      margin-bottom:30px;
    }
    .ptitle{
        font-size:1.3em;
        color:#fff;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, .5);
        line-height:1.3;
    }
    .ptext{
        font-size:0.7em;
        color:#fff;
        text-align:center;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, .5);
    }
}

.wrap-container-wrap {
    width: 100%;
    width: 100vw;
    margin-left: -18px;
    white-space: nowrap;
    overflow: hidden;
    overflow-x: scroll; /* 1 */
    -webkit-backface-visibility: hidden;
    -webkit-perspective: 1000;
    -webkit-overflow-scrolling: touch; /* 2 */
    text-align: justify; /* 3 */
    &::-webkit-scrollbar {
        display: none;
    }
}

.wrap-container {
    
}
.wrap-container > div {
    display: inline-block;
    color: #fff;
    text-align: center;
}
.box-image {
  padding-left:18px;
  width: 70%;
  img{
    width:100%;
    border-radius:6px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/other/index.vue